document.addEventListener( 'DOMContentLoaded', () => {
	// Use the actual wrapper class generated by useBlockProps/save.
	const blocks = document.querySelectorAll( '.mu-gallery-lightbox' );

	if ( ! blocks.length ) {
		return;
	}

	blocks.forEach( ( block ) => {
		const images = [ ...block.querySelectorAll( '.gallery-columns img' ) ];
		const overlay = block.querySelector( '.mu-gallery-lightbox-overlay' );

		if ( ! images.length || ! overlay ) {
			return;
		}

		const backdrop = overlay.querySelector( '.mu-gallery-lightbox-backdrop' );
		const closeBtn = overlay.querySelector( '.mu-gallery-lightbox-close' );
		const prevBtn = overlay.querySelector( '.mu-gallery-lightbox-nav.prev' );
		const nextBtn = overlay.querySelector( '.mu-gallery-lightbox-nav.next' );
		const lightboxImg = overlay.querySelector( '.mu-gallery-lightbox-img' );

		if ( ! lightboxImg || ! backdrop || ! closeBtn || ! prevBtn || ! nextBtn ) {
			return;
		}

		let currentIndex = 0;

		const openOverlay = ( index ) => {
			currentIndex = index;
			const img = images[ currentIndex ];
			if ( ! img ) {
				return;
			}
			lightboxImg.setAttribute( 'src', img.getAttribute( 'src' ) || '' );
			lightboxImg.setAttribute( 'alt', img.getAttribute( 'alt' ) || '' );
			overlay.classList.add( 'is-visible' );
		};

		const closeOverlay = () => {
			overlay.classList.remove( 'is-visible' );
		};

		const showNext = () => {
			currentIndex = ( currentIndex + 1 ) % images.length;
			openOverlay( currentIndex );
		};

		const showPrevious = () => {
			currentIndex = ( currentIndex - 1 + images.length ) % images.length;
			openOverlay( currentIndex );
		};

		images.forEach( ( img, idx ) => {
			img.style.cursor = 'pointer';
			img.addEventListener( 'click', () => {
				openOverlay( idx );
			} );
		} );

		closeBtn.addEventListener( 'click', closeOverlay );
		backdrop.addEventListener( 'click', closeOverlay );

		nextBtn.addEventListener( 'click', ( e ) => {
			e.stopPropagation();
			showNext();
		} );

		prevBtn.addEventListener( 'click', ( e ) => {
			e.stopPropagation();
			showPrevious();
		} );

		document.addEventListener( 'keydown', ( e ) => {
			if ( ! overlay.classList.contains( 'is-visible' ) ) {
				return;
			}

			if ( e.key === 'Escape' ) {
				closeOverlay();
			} else if ( e.key === 'ArrowRight' ) {
				showNext();
			} else if ( e.key === 'ArrowLeft' ) {
				showPrevious();
			}
		} );
	} );
} );
